import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MinimizedSidebar } from '@/components/MinimizedSidebar';
import { ChannelOverviewContent } from '@/components/ChannelOverviewContent';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ChannelOverviewPage() {
  const { ibId } = useParams();
  const navigate = useNavigate();
  const [ib, setIb] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const fetchIBData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await axios.get(`${API}/ib/${ibId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIb(response.data);
      } catch (error) {
        toast.error('Failed to load IB data');
        if (error.response?.status === 401) {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchIBData();
  }, [ibId, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen bg-[#09090B] text-white items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-[#09090B] text-white">
      <MinimizedSidebar 
        collapsed={sidebarCollapsed} 
        setCollapsed={setSidebarCollapsed}
        currentIB={ib}
      />
      
      <main className={`flex-1 flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : ''}`}>
        {ib && <ChannelOverviewContent ib={ib} />}
      </main>
    </div>
  );
}
